import React from 'react';
import { Box, Typography } from '@mui/material';
import RaceDetailHeader from './RaceDetailHeader';
import WinRateChart from './WinRateChart';
import AiRecommendedHorses from './AiRecommendedHorses';
import AiFocusHorses from './AiFocusHorses';
import HorseDataTable from './HorseDataTable';
import EvBetPanel from './EvBetPanel';
import { AI_INDEX_NOTE } from './utils';
import './raceDetail.css';

function RaceDetailPage({ model }) {
  return (
    <Box className="race-detail-shell">
      <RaceDetailHeader
        raceDate={model.raceDate}
        surfaceLabel={model.surfaceLabel}
        roughness={model.roughness}
        raceConfidence={model.raceConfidence}
        stats={model.stats}
      />

      <Box className="race-detail-hero-grid">
        <Box className="race-detail-main-column">
          <WinRateChart
            chartData={model.chartData}
            eyebrow={model.chartEyebrow}
            title={model.chartTitle}
            oddsLabel={model.chartOddsLabel}
            highlightPicks={model.chartHighlightPicks}
          />
        </Box>
        <Box className="race-detail-side-column">
          <AiRecommendedHorses
            horses={model.recommendedHorses}
            eyebrow={model.recommendEyebrow}
            title={model.recommendTitle}
            showNote={false}
          />
          <AiFocusHorses
            horses={model.focusHorses}
            eyebrow={model.focusEyebrow}
            title={model.focusTitle}
            showNote={false}
          />
        </Box>
      </Box>

      <Box sx={{ mt: 2.5 }} id="race-detail-table">
        <HorseDataTable
          horses={model.horses}
          eyebrow={model.tableEyebrow}
          title={model.tableTitle}
          columns={model.tableColumns}
          showNote={false}
        />
      </Box>

      {model.evBetsPanel && (
        <Box sx={{ mt: 2.5 }}>
          <EvBetPanel
            bets={model.evBetsPanel.bets}
            eyebrow={model.evBetsPanel.eyebrow}
            title={model.evBetsPanel.title}
            emptyText={model.evBetsPanel.emptyText}
            showNote={false}
          />
        </Box>
      )}

      {/* 注記は 1 ページに 1 回。各パネルは showNote={false} で抑止している。 */}
      <Typography className="race-detail-table-subtext" sx={{ mt: 2.5, display: 'block' }}>
        ※ {AI_INDEX_NOTE}
      </Typography>
    </Box>
  );
}

export default RaceDetailPage;
